import {
  JWTClaimsRole,
  permissionsEnumSchema,
  psychologistHeadlineEnumSchema,
} from "@mindlercare/schema";
import CONSTANTS from "core/constants";
import { Slot } from "../../core/types";

const SwedenStrategy = {
  patientCardTabs: {
    BOOKINGS: CONSTANTS.PATIENT_CARD_TABS.BOOKINGS,
    ICBT: CONSTANTS.PATIENT_CARD_TABS.ICBT,
    PROMOCODES: CONSTANTS.PATIENT_CARD_TABS.PROMOCODES,
    ACTIONS: CONSTANTS.PATIENT_CARD_TABS.ACTIONS,
  },
  patientSearchFields: {
    FIRSTNAME: CONSTANTS.SEARCH_TERMS.FIRSTNAME,
    LASTNAME: CONSTANTS.SEARCH_TERMS.LASTNAME,
    USER_ID: CONSTANTS.SEARCH_TERMS.USER_ID,
    EMAIL: CONSTANTS.SEARCH_TERMS.EMAIL,
    NATIONAL_IDENTITY: CONSTANTS.SEARCH_TERMS.NATIONAL_IDENTITY,
  },
  psychologist: {
    userData: {
      rows: [
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_NAME,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
          .UNEDITABLE_NATIONAL_ID_AND_EMAIL,
        CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
          .EDITABLE_PHONE_NUMBER_AND_HSA,
      ],
    },
    headlineKeys: [psychologistHeadlineEnumSchema.enum.licensed],
    hasRequiredAdeli: false,
    hasPersonnummer: true,
  },
  specialities: {
    hasFilteredSpecialities: false,
  },
  slots: {
    isPayable: true,
  },
  marketHasStatisticsDashboard: false,
  slotTemplates: [
    CONSTANTS.SLOT_TEMPLATES.NEW_VISIT,
    CONSTANTS.SLOT_TEMPLATES.TECH_TEST,
    CONSTANTS.SLOT_TEMPLATES.BLOCKER,
    CONSTANTS.SLOT_TEMPLATES.SHORT_VISIT,
    CONSTANTS.SLOT_TEMPLATES.REVISIT,
    CONSTANTS.SLOT_TEMPLATES.COUPLES_THERAPY,
    CONSTANTS.SLOT_TEMPLATES.FEEDBACK,
  ],
  patientCard: {
    status_label: "STATUS",
  },
  showEditPatientDetails: false,
  showRevisitLabelSuffix: true,
  showInsuranceInfoPsychologist: false,
  showInsuranceInfoAdmin: false,
  showInsurancePlan: true,
  showSavedCardStatus: false,
  showExtraInfoPatientBookings: false,
  showSessionCountColumn: false,
  changeSlotStatus: {
    enabled: true,
    enabledForRoles: [] as JWTClaimsRole[],
    enabledForPermission: permissionsEnumSchema.enum.EDIT_PATIENT_DETAILS,
    feeStatuses: [CONSTANTS.BOOKING_STATUS.LATE_CANCELED] as Slot["status"][],
    getSlotStatuses: () => {
      return CONSTANTS.UPDATABLE_BOOKING_STATUS;
    },
  },
  clinicalGuidelinesHref:
    "https://docs.google.com/document/d/1CRg1W-Lhh-kwGIlykupUieLTOd_oTzIOco1AGQNjR8s/edit#heading=h.5gky218m3u17",
};

export default SwedenStrategy;
